const TRUST_DEED_DOCUMENT_TYPES = {
  TRUST_DEED: {
    value: "trust_deed",
    readableName: "Trust Deed",
  },
  TRUST_AGREEMENT: {
    value: "trust_agreement",
    readableName: "Trust Agreement",
  },
  TRUST_DECLARATION: {
    value: "declaration_of_trust",
    readableName: "Declaration of Trust",
  },
};

export const trustDeedDocumentTypesArray = Object.values(TRUST_DEED_DOCUMENT_TYPES);
